// extracted by mini-css-extract-plugin
export var banner = "banner-share-module--banner--a5177";
export var bannerFixed = "banner-share-module--bannerFixed--83ec9";
export var btn = "banner-share-module--btn--e58dc";
export var contentDesktop = "banner-share-module--contentDesktop--559cc";
export var icons = "banner-share-module--icons--6795f";
export var tooltip = "banner-share-module--tooltip--ccd2d";
export var visible = "banner-share-module--visible--033e6";
export var wrapperBtn = "banner-share-module--wrapperBtn--978be";
export var wrapperShare = "banner-share-module--wrapperShare--3a596";